import { render, staticRenderFns } from "./CompletionStatuses.vue?vue&type=template&id=33556b5c"
import script from "./CompletionStatuses.vue?vue&type=script&lang=js"
export * from "./CompletionStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports